export const menu = [
  //עיקריות  
    { name: "קציצות דגים ברוטב מרוקאי חריף", Dish: "Fish Patties in Spicy Moroccan Sauce", 
    Price: 25, 
    Amount:"200 גרם",quantity:"7 Oz",img:"/Fish-Pettice.jpeg",category:"Main-Dishs/עיקריות"},
  
    { name: "סטייק פרגית בתיבול ים תיכוני", Dish: "Grilled Chicken Thigh Steak with Mediterranean Seasoning", 
    Price: 20, 
    Amount:"200 גרם",quantity:"7 Oz",img:"/pargit.jpg",category:"Main-Dishs/עיקריות"},
  
    { name: "בשר בקר בבישול ארוך עם בצל מקורמל", Dish: "Slow-cooked beef with caramelized onions", 
    Price: 25, 
    Amount:"200 גרם",quantity:"7 Oz",img:"/Meat.jpeg",category:"Main-Dishs/עיקריות"},
    { 
      name: "שניצל ביתי",
      Dish: "Homemade Schnitzel",
      Price: 20,
      Amount: "200 גרם",
      quantity: "7 Oz",
      img: "/shnizel.jpeg",
      category: "Main-Dishs/עיקריות"
    },
  
  //  { name: "בשר כבש בבצל מקורמל", Dish: "Lamb with Caramelized Onions", 
  //  Price: 20, 
  //  Amount:"200 גרם",quantity:"7 Oz",img:"/lean.jpg",category:"Main-Dishs/עיקריות"},
  
    { name: "קציצות בשר ברוטב עגבניות", Dish: "Beef Meatballs in Tomato Sauce", 
    Price: 25, 
    Amount:"200 גרם",quantity:"7 Oz",img:"/meatBall.jpeg",category:"Main-Dishs/עיקריות"},
  
    { name: "דג סלמון ברוטב פלפלים מרוקאי", Dish: "Salmon Fish in Spicy Moroccan Sauce", 
    Price: 25, 
    Amount:"200 גרם",quantity:"7 Oz",img:"/SalmonFish.jpg",category:"Main-Dishs/עיקריות"},
  //מרקים
    { name: "מרק ירקות לקוסקוס", Dish: "Vegetable Soup for Couscous", 
    Price: 20, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/vsoup.jpeg",category:"Soups/מרקים"},
    
    { name: "מרק עדשים ירוקות", Dish: "Lentil soup", 
    Price: 20, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/Lentil-soup.jpg",category:"Soups/מרקים"},
    
    { name: "מרק בצל", Dish: "Onion soup", 
    Price: 20, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/onion-soup.jpg",category:"Soups/מרקים"},
    
    { name: "מרק שעועית", Dish: "Bean soup", 
    Price: 20, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/Bean_Soup.jpg",category:"Soups/מרקים"},
    //תוספות
    { 
  name: "פלפלונים ממולאים אורז",
  Dish: "Rice-Stuffed Mini Peppers",
  Price: 15,
  Amount: "250 גרם 3 יחידות",
  quantity: "9oz 3unit",
  img: "/mini_paper_whit_rice.jpg",
  category: "Side-Dishs/תוספות"
},
{ 
  name: "בצל ממולא אורז",
  Dish: "Rice-Stuffed Onions",
  Price: 15,
Amount: "250 גרם 3 יחידות",
  quantity: "9oz 3unit",
  img: "/onion_whit_rice.jpg",
  category: "Side-Dishs/תוספות"
},
    { name: "קוסקוס ביתי אמיתי", Dish: "Authentic Homemade Couscous", 
    Price: 25, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/cuscus.jpeg",category:"Side-Dishs/תוספות"  },
     { name: "לביבות תפוחי אדמה (לאטקס)", Dish: "Potato Latkes", 
    Price: 25, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/Levivot.jpg",category:"Side-Dishs/תוספות"  },
   
//  { name: "דלעת מתוקה עם צימוקים", Dish: "Sweet Pumpkin with Raisins", 
//    Price: 10, 
//    Amount:"200 גרם",quantity:"7 Oz",img:"/pumkin.jpeg",category:"Side-Dishs/תוספות"},
  
    { name: "אורז עם שבבי בצל וגזר", Dish: "Rice with Onion Chips and Carrots", 
    Price: 20, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/Rice.jpg",category:"Side-Dishs/תוספות"},
    
    { name: "אורז לבן ביתי  ", Dish: " Homestyle White Rice", 
    Price: 20, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/RiceW.png",category:"Side-Dishs/תוספות"},
  

    { name: "תפוחי אדמה בעשבי תיבול בתנור", Dish: "Roasted Potatoes with Herbs", 
    Price: 25, 
    Amount:"500 גרם",quantity:"17.5 Oz",img:"/potetos.jpg",category:"Side-Dishs/תוספות"},
//סלטים
    { name: "סלט מטבוחה ביתי חריף", Dish: "Homemade Spicy Matbucha Salad", 
    Price: 15, 
    Amount:"150 גרם",quantity:"5.5 Oz",img:"/matbucha.jpeg",category:"Salads/סלטים"},
  
    { name: "סלט חומוס ביתי", Dish: "Homemade Hummus", 
    Price: 15, 
    Amount:"150 גרם",quantity:"5.5 Oz",img:"/hummus.jpg",category:"Salads/סלטים"},  
  
    { name: "סלט סלק אדום מגורד", Dish: "Red grated beet salad", 
    Price: 10, 
    Amount:"150 גרם",quantity:"5.5 Oz",img:"/Red-grated.jpg",category:"Salads/סלטים"},
  
    { name: "סלט טחינה ירוקה", Dish: "Green Tahini Salad", 
    Price: 15, 
    Amount:"150 גרם",quantity:"5.5 Oz",img:"/Green-Tahini.jpeg",category:"Salads/סלטים"},  
  //מגשים
    { name: "מגש שקשוקה", Dish: "Shakshuka Tray", 
    Price: 50, 
    Amount:"10 ביצים",quantity:"10 eggs",img:"/shakshuka.jpg",category:"Trays/מגשים"},
//  //מוצרים 
  //  { name: "טחינה הר ברכה", Dish: "Har Braha thini", 
    //Price: 10, 
  //  Amount:"500 גרם",quantity:"17.630oz",img:"/israeliProdact/thini.png",category:"IsraeliProdact/מוצרים ישראלים"},
  //  { name: "כריות תלמה", Dish: "Telma Nougat Creme Filled Kariot Cereal", 
  //  Price: 12, 
  //  Amount:"686 גרם",quantity:"24.2oz",img:"/israeliProdact/kariot.jpg",category:"IsraeliProdact/מוצרים ישראלים"},
  //  { name: "פריגת במגוון טעמים", Dish: "Prigat ", 
    //Price: 7, 
    //Amount:"1.5 ליטר",quantity:"50.7oz",img:"/israeliProdact/prigat.png",category:"IsraeliProdact/מוצרים ישראלים"}
];